@let isLoggedUser = userId && currentUser()?.id && userId === currentUser()?.id;

<div class="flex flex-column gap-3">
	<div class="flex flex-column gap-3">
		<p-divider align="left"><strong>Informazioni utente</strong></p-divider>
		@for (field of fields; track field.key) {
			<app-inline-field [label]="field.label"
							  [value]="user()?.[field.key]"
							  [type]="field.type"
							  [editable]="field.editable"
							  [options]="field.options"
							  (save)="updateField(field.key, $event)"
			></app-inline-field>
		}
	</div>
	@if (isLoggedUser) {
		<app-user-password-panel />
	}

	@if(userId !== currentUser()?.id) {
		<app-user-roles-panel [userId]="userId" />
	}

	<div class="flex justify-content-end gap-2">
		@if (!isLoggedUser) {
			<p-button label="Rimuovi utente"
					  size="small"
					  plain
					  severity="danger"
					  (onClick)="deleteUser(userId)" />
		}

		@if( user()?.first_login ) {
			<p-button label="Reinvia la email di registrazione"
					  size="small"
					  plain
					  severity="secondary"
					  (onClick)="resendRegistration()" />
		}
	</div>
</div>
